export default [
	{
		path: "/login",
		name: "Login",
		component: () => import("@/views/auth/LoginPage")
	},
	{
		path: "/logout",
		name: "Logout",
		component: () => import("@/views/auth/Logout")
	},
	{
		path: "/register",
		name: "Register",
		component: () => import("@/views/auth/RegisterPage")
	},
	{
		path: "/reset-password/:code",
		name: "ResetPassword",
		component: () => import("@/views/auth/PasswordReset")
	},
	{
		path: "/forgot-password",
		name: "ForgotPassword",
		component: () => import("@/views/auth/PasswordForgot")
	}
]
